import React from 'react';
import PropTypes from 'prop-types';

import Errors from '../Errors';
import FormRow from './FormRow';
import FormRowSubmit from './FormRowSubmit';

class Form extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    items: PropTypes.array,
    errors: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.string
    ])
  };

  static defaultProps = {
    disabled: false,
    submitText: 'button.send',
    className: '',
    context: null,
    values: {},
    errors: [],
    items: [],
    stateless: false
  };

  constructor(props) {
    super(props);
    this.state = {
      values: this.getValues(props.values)
    };
  }

  getValues(values) {
    if (!this.props.items) return {};
    let item, i, j, itm;
    for (i = 0; i < this.props.items.length; i++) {
      item = this.props.items[i];
      if (values[item.name] == null || values[item.name] === undefined) {
        if (item.type === 'cols') {
          for (j = 0; j < item.items.length; j++) {
            itm = item.items[j];
            if (values[itm.name] == null || values[itm.name] === undefined) {
              values[itm.name] = itm.value != null
                ? itm.value
                : (itm.defaultValue ? itm.defaultValue : '');
            }
          }
        } else {
          values[item.name] = item.value != null
            ? item.value
            : (item.defaultValue ? item.defaultValue : '');
        }
      }
    }
    return values;
  }

  componentDidUpdate(prevProps) {
    if (this.props.stateless) {
      return;
    }

    if (prevProps.values !== this.props.values || prevProps.items !== this.props.items) {
      this.setState({
        values: this.getValues(this.props.values)
      });
    }
  }

  handleChange = (name, value) => {
    let values;
    if (this.props.stateless) {
      values = Object.assign({}, this.props.values);
      values[name] = value;
    } else {
      values = this.state.values;
      values[name] = value;
      this.setState({ values: values });
    }
    this.props.onChange && this.props.onChange(values);
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (!this.props.onSubmit) {
      return;
    }
    this.props.onSubmit();

    let values = Object.assign({}, this.state.values);
    for (let key in values) {
      if (typeof values[key] == 'string') {
        values[key] = '';
      }
    }

    if (!this.props.stateless) {
      this.setState({ values: values });
    }
  };

  render() {
    let rows = [], values, i, item;

    if (this.props.stateless) {
      values = this.getValues(Object.assign({}, this.props.values));
    } else {
      values = this.state.values;
    }

    for (i = 0; i < this.props.items.length; i++) {
      item = this.props.items[i];

      rows.push(
        <FormRow label={item.label}
          type={item.type}
          context={this.props.context}
          data={item}
          autoFocus={item.autoFocus || i === 0}
          value={values[item.name]} name={item.name}
          options={item.options}
          disabled={this.props.disabled}
          onChange={this.handleChange}
          key={i} />);
    }

    return (
      <form onSubmit={this.onSubmit}>
        {rows}
        <Errors errors={this.props.errors} />
        <div className="form_buttons">
          {this.props.submitText ?
            <FormRowSubmit status={this.props.submitStatus} text={this.props.submitText}
              disabled={this.props.disabled} />
            : null}
          {this.props.children}
        </div>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/js/Component/Form/Form.jsx